import React from 'react'
import style from './style.module.less'

const statusColor = ['#448AFC', '#FF9037', '#FF4B4B']

const OtherCourseGuide = ({ info }) => {
  return (
    <div className={style.otherCourseGuide}>
      <ul className={style.module}>
        {info?.map((item, i) => (
          <>
            {!!item?.list?.length && (
              <li key={i} className={style.moduleItems}>
                <div className={style.moduleTitle}>{item.title}</div>
                <ul className={style.task}>
                  {item.list?.map((el, i) => (
                    <li key={i} className={style.taskItems}>
                      <div className={style.top}>
                        <img
                          className={style.icon}
                          width={20}
                          height={20}
                          src={
                            el.icon ||
                            'https://qnm.hunliji.com/Ftb3L35Q12hbmEB0IqiDlAp7YoZY'
                          }
                        />
                        <span className={style.taskTitle}>{el.taskName}</span>
                        <span
                          onClick={() => (window.location.href = el.webRoute)}
                          className={style.action}
                          style={{ color: statusColor[el.status] }}
                        >
                          {el.buttonText}
                        </span>
                      </div>
                      <div className={style.bottom}>
                        <span className={style.desc}>
                          {el.taskDeputyCopywriter}
                        </span>
                      </div>
                    </li>
                  ))}
                </ul>
              </li>
            )}
          </>
        ))}
      </ul>
    </div>
  )
}

export default OtherCourseGuide
